<template>
    <div class="result-message">
        <div
            class="result-message__icon"
            :class="isSuccess ? 'result-message__icon--success' : 'result-message__icon--error'"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
            >
                <path
                    v-if="isSuccess"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12l2 2l4-4m6 2a9 9 0 11-18 0a9 9 0 0118 0z"
                />
                <path
                    v-else
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                />
            </svg>
        </div>

        <h2 :class="isSuccess ? 'result-message__title--success' : 'result-message__title--error'">
            {{ title }}
        </h2>

        <div v-if="$slots.default" class="result-message__content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "ResultMessage",
    props: {
        type: {
            type: String,
            default: "success",
        },
        title: {
            type: String,
            required: true,
        },
    },
    computed: {
        isSuccess() {
            return this.type === "success";
        },
    },
};
</script>

<style scoped>
.result-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 8px;
    text-align: center;
}

.result-message__icon {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    border-radius: 50%;
}

.result-message__icon svg {
    width: 32px;
    height: 32px;
}

.result-message__icon--success {
    background: #ecfdf5;
    color: #22c55e;
}

.result-message__icon--error {
    background: #fef2f2;
    color: #ef4444;
}

.result-message h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
}

.result-message__title--success {
    color: #16a34a;
}

.result-message__title--error {
    color: #dc2626;
}

.result-message__content {
    margin-top: 12px;
    color: #4b5563;
    font-size: 14px;
}

.result-message__content p {
    margin: 4px 0;
}
</style>